import { Mention } from "@tiptap/extension-mention";

import { itemsFn, renderMenu } from "./menu";

export const MENTION_CHAR = "@";

interface MentionsOptions {
  getMentions: () => string[];
  allowCreate?: boolean;
}

// Note: would have been nice to use Mention.extend but couldn't make it work with a custom options: `mentions`
export const MentionsExtension = {
  configure: (options: MentionsOptions) => {
    return Mention.configure({
      suggestions: [
        {
          char: MENTION_CHAR,

          allowedPrefixes: [" "],
          allowSpaces: false,
          startOfLine: false,

          items: itemsFn(options.getMentions, {
            allowCreate: options.allowCreate ?? false,
          }),
          render: () => renderMenu("mention"),
        },
      ],
    });
  },
};
